import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCButton from '../../../../components/Simple/SMCButton';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import Indentation from '../../../../components/Simple/Indentation';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import {SMCSelect, SMCOption} from '../../../../components/Simple/SMCSelect';
import GatewayManageCertificateModal from '../../../PopupPages/GatewayManageCertificateModal';
import {useBoolean} from '../../../../utils/hooks';

const pageSchema = GatewayGetSchema.pages.vpnAuthenticationMethod;
const pageId = pageSchema.pageId;

function GatewayVpnAuthenticationMethod({
    gatewayObject,
    setGatewayData,
    isExternal
}) {
    const { t } = useTranslation();

    const pageData = gatewayObject[pageId];

    const vpnAuthMethod        = pageData[pageSchema.vpnAuthMethod];
    const certificateAuthority = pageData[pageSchema.certificateAuthority];
    const externalCertSubject  = pageData[pageSchema.externalCertSubject];
    const fullDn               = pageData[pageSchema.fullDn];
    const sharedSecret         = pageData[pageSchema.sharedSecret];

    const vpnAuthMethodValues = pageSchema.vpnAuthMethodValues;
    const internalCaValue     = pageSchema.internalCaValue;
    
    const setPageData = useCallback((paramName, newValue) => {
        setGatewayData([pageId, paramName], newValue);
    }, [setGatewayData]);

    const gatewayId = gatewayObject[GatewayGetSchema.id];
    const [isManageCertificateModalOpen, openManageCertificateModal, closeManageCertificateModal] = useBoolean(false);

    return (
        <EditorLayout>
            <SMCSelect
                value={vpnAuthMethod}
                disabled={true}
                label={t('SMP.GATEWAYS.PAGE.VPN.AUTH_METHOD')}
            >
                <SMCOption value={vpnAuthMethodValues.certificate}>{t('SMP.GATEWAYS.PAGE.VPN.CERTIFICATE')}</SMCOption>
                <SMCOption value={vpnAuthMethodValues.sharedSecret}>{t('SMP.GATEWAYS.PAGE.VPN.SHARED_SECRET')}</SMCOption>
            </SMCSelect>
            {
                vpnAuthMethod === vpnAuthMethodValues.certificate && !isExternal && (
                    <>
                    <SMCSelect
                        value={certificateAuthority}
                        disabled={true}
                        label={t('SMP.GATEWAYS.PAGE.VPN.CERT_AUTHORITY')}
                    >
                        <SMCOption value={internalCaValue}>{t('SMP.GATEWAYS.PAGE.VPN.CERT_AUTHORITY.INTERNAL_CA')}</SMCOption>
                        {/* If ca isn't Internal_CA, show that value without translation */}
                        {
                            certificateAuthority !== internalCaValue && (
                                <SMCOption value={certificateAuthority}>{certificateAuthority}</SMCOption>
                            )
                        }
                    </SMCSelect>
                    {
                        certificateAuthority === internalCaValue && (
                            <SMCTextInput
                                value={fullDn}
                                disabled={true}
                                label={t('SMP.GATEWAYS.PAGE.VPN.DISTINGUISHED_NAME')}
                            />
                        )
                    }
                    {
                        certificateAuthority !== internalCaValue && (
                            <SMCTextInput
                                value={externalCertSubject}
                                disabled={true}
                                label={t('SMP.GATEWAYS.PAGE.VPN.DISTINGUISHED_NAME')}
                            />
                        )
                    }
                    <Indentation indentation={200}>
                        <SMCButton disabled={certificateAuthority === internalCaValue} onClick={openManageCertificateModal}>{t('SMP.GATEWAYS.PAGE.VPN.MANAGE_CERT')}</SMCButton>
                    </Indentation>
                    </>
                )
            }
            {
                vpnAuthMethod === vpnAuthMethodValues.sharedSecret && (
                    <SMCTextInput
                        value={sharedSecret}
                        onChange={e => setPageData(pageSchema.sharedSecret, e.target.value)}
                        label={t('SMP.GATEWAYS.PAGE.VPN.SHARED_SECRET')}
                    />
                )
            }
            {/* Popup pages */}
            <GatewayManageCertificateModal
                isOpen={isManageCertificateModalOpen}
                onRequestClose={closeManageCertificateModal}
                gatewayId={gatewayId}
            />
        </EditorLayout>
    );
}

export default GatewayVpnAuthenticationMethod;